import React from 'react';

import { Close } from '@mui/icons-material';
import { AppBar, Dialog, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

interface FullscreenDialogProps {
    isOpen: boolean;
    onClose: () => void;
    children?: React.ReactNode;
}

const DialogTransition = React.forwardRef(function Transition(props: TransitionProps & { children: React.ReactElement }, ref: React.Ref<unknown>) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FullscreenDialog = ({ isOpen, onClose, children }: FullscreenDialogProps) => (
    <Dialog fullScreen open={isOpen} onClose={onClose} TransitionComponent={DialogTransition}>
        <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close" size="large">
                    <Close />
                </IconButton>
                <Typography variant="h6">Channel Editor</Typography>
            </Toolbar>
        </AppBar>
        {children}
    </Dialog>
);

export default FullscreenDialog;
